/** Textos da secção "account". Chaves planas "account.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "account.adminPortal": "Portal de administração",
    "account.backToSite": "Voltar ao site",
    "account.eyebrow": "Área pessoal",
    "account.hello": "Olá,",
    "account.intro":
        "Geres a tua conta ZRS, consultas resumos e acede rapidamente aos serviços da rede. Em breve: histórico de compras e carrinho ligados à loja.",

    "account.player.title": "Perfil de jogador",
    "account.player.steamLinked": "Conta Steam associada ao teu perfil ZRS.",
    "account.player.steamRequired":
        "A SteamID é obrigatória para comprar VIP/kit e usar o simulador VIP personalizado.",

    "account.card.accountLabel": "Conta",
    "account.card.discordLinked": "Discord ligado",
    "account.card.discordBody":
        "Início de sessão seguro via Supabase. O teu perfil público segue as definições do Discord.",
    "account.card.statusLabel": "Estado",
    "account.card.active": "Conta ativa",
    "account.card.activeBody": "Sessão válida. Quando a loja estiver ligada, as compras aparecem abaixo.",
    "account.card.memberSince": "Membro desde",
    "account.card.memberSinceBody": "Data da primeira ligação desta conta ao site ZRS.",

    "account.quick.title": "Ações rápidas",
    "account.quick.servers": "Servidores ativos",
    "account.quick.serversSub": "Estado, jogadores e wipe",
    "account.quick.vip": "Planos VIP",
    "account.quick.vipSub": "Benefícios e kits",
    "account.quick.kits": "Kits de compra única",
    "account.quick.kitsSub": "Pacotes one-shot",
    "account.quick.shop": "Loja & guia",
    "account.quick.shopSub": "Como comprar com Pix",
    "account.quick.simulator": "Simulador VIP",
    "account.quick.simulatorSub": "Monta o teu kit personalizado",

    "account.summary.title": "Resumo da conta",
    "account.summary.discord": "Discord ZRS",
    "account.history.title": "Histórico de compras",
    "account.history.emptyTitle": "Ainda sem compras",
    "account.history.emptyBody":
        "Quando finalizares encomendas na loja ZRS, o histórico aparece aqui com data, valor e estado.",
    "account.cart.title": "Carrinho",
    "account.cart.emptyTitle": "Carrinho vazio",
    "account.cart.emptyBody":
        "Adiciona VIP ou kits quando a checkout estiver disponível. Este painel está preparado para listar itens e totais.",
};

const en = {
    "account.adminPortal": "Admin portal",
    "account.backToSite": "Back to site",
    "account.eyebrow": "Personal area",
    "account.hello": "Hey,",
    "account.intro":
        "Manage your ZRS account, check summaries and jump straight to the network's services. Coming soon: purchase history and cart linked to the shop.",

    "account.player.title": "Player profile",
    "account.player.steamLinked": "Steam account linked to your ZRS profile.",
    "account.player.steamRequired":
        "A SteamID is required to buy VIP/kits and use the custom VIP simulator.",

    "account.card.accountLabel": "Account",
    "account.card.discordLinked": "Discord linked",
    "account.card.discordBody":
        "Secure sign-in via Supabase. Your public profile follows your Discord settings.",
    "account.card.statusLabel": "Status",
    "account.card.active": "Account active",
    "account.card.activeBody": "Session valid. Once the shop is connected, your purchases will show up below.",
    "account.card.memberSince": "Member since",
    "account.card.memberSinceBody": "Date this account first signed in to the ZRS site.",

    "account.quick.title": "Quick actions",
    "account.quick.servers": "Active servers",
    "account.quick.serversSub": "Status, players and wipe",
    "account.quick.vip": "VIP plans",
    "account.quick.vipSub": "Perks and kits",
    "account.quick.kits": "One-time kits",
    "account.quick.kitsSub": "One-shot packs",
    "account.quick.shop": "Shop & guide",
    "account.quick.shopSub": "How to buy with Pix",
    "account.quick.simulator": "VIP Simulator",
    "account.quick.simulatorSub": "Build your custom kit",

    "account.summary.title": "Account summary",
    "account.summary.discord": "ZRS Discord",
    "account.history.title": "Purchase history",
    "account.history.emptyTitle": "No purchases yet",
    "account.history.emptyBody":
        "Once you complete orders in the ZRS shop, your history will show up here with date, amount and status.",
    "account.cart.title": "Cart",
    "account.cart.emptyTitle": "Cart is empty",
    "account.cart.emptyBody":
        "Add VIP or kits once checkout is available. This panel is ready to list items and totals.",
};

export default { pt, en };
